(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.documentElement.classList.add('azan-motion-ready');

  const progress = document.createElement('div');
  progress.className = 'azan-scroll-progress';
  progress.setAttribute('aria-hidden', 'true');
  progress.innerHTML = '<span></span>';
  document.body.appendChild(progress);

  const progressFill = progress.querySelector('span');

  const updateProgress = () => {
    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    const ratio = maxScroll > 0 ? window.scrollY / maxScroll : 0;
    progressFill.style.transform = `scaleX(${Math.min(Math.max(ratio, 0), 1)})`;
  };

  updateProgress();
  window.addEventListener('scroll', updateProgress, { passive: true });
  window.addEventListener('resize', updateProgress);

  if (reduceMotion.matches) return;

  /* Blocks with the "No animation" setting (.hero-split--static) and their section wrapper are left still. */
  const isStatic = (el) => !!(el.closest('.hero-split--static') || (el.matches('.shopify-section') && el.querySelector('.hero-split--static')));
  const revealTargets = Array.prototype.filter.call(document.querySelectorAll(
    '.template-index .shopify-section, .template-index .grid__item, .template-index .hero-split__content, .template-index .hero-split__image, .template-index .hero-split__video, .template-index .multicolumn-card, .template-index .image-banner, .footer'
  ), (el) => !isStatic(el));

  revealTargets.forEach((target) => {
    target.classList.add('azan-reveal');
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
  );

  revealTargets.forEach((target) => observer.observe(target));

  const parallaxItems = Array.prototype.filter.call(document.querySelectorAll(
    '.template-index .hero-split__image img, .template-index .hero-split__video video, .template-index .card__media img, .template-index .multicolumn-card__image'
  ), (el) => !isStatic(el));

  let ticking = false;
  /* Last value written per item (same index as parallaxItems, a static
     NodeList), so an unchanged offset is not written again. */
  const parallaxValues = new Array(parallaxItems.length);
  const updateParallax = () => {
    /* Pages without parallax targets read nothing (an innerHeight read after the
       progress-bar write forces a style recalc per frame on mobile). */
    if (!parallaxItems.length) return;
    /* All layout reads first, then all writes: a write between two
       getBoundingClientRect() calls forced a style recalc per item. */
    const viewportMid = window.innerHeight / 2;
    const rects = Array.prototype.map.call(parallaxItems, (item) => item.getBoundingClientRect());
    parallaxItems.forEach((item, index) => {
      const rect = rects[index];
      const itemMid = rect.top + rect.height / 2;
      const offset = (viewportMid - itemMid) * 0.018;
      const value = `${Math.max(Math.min(offset, 18), -18)}px`;
      if (parallaxValues[index] === value) return;
      parallaxValues[index] = value;
      item.style.setProperty('--azan-parallax-y', value);
    });
    ticking = false;
  };

  const requestParallax = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateParallax);
  };

  requestParallax();
  window.addEventListener('scroll', requestParallax, { passive: true });
  window.addEventListener('resize', requestParallax);
})();
